import { Locale } from 'antd/lib/locale-provider';
import vi from './vi';
import en from './en';

// Kept free of any extra key: this object is handed to i18next as `resources`,
// which reads every key as a namespace.
const languages = {
  vi: { translations: vi.translations },
  en: { translations: en.translations },
};

const antLocales: { [key: string]: Locale } = {
  vi: vi.antLocale,
  en: en.antLocale,
};

const regions: { [key: string]: { name: string } } = {
  vi: { name: vi.name },
  en: { name: en.name },
};

export { languages, antLocales, regions };
